import Welcome from "./Welcome";
import WelcomeExp from "./WelcomeExp";
import ReadingList from "./ReadingList";

import { useFeatureIsOn } from "@growthbook/growthbook-react";

function Start() {
  const isExp47 = useFeatureIsOn("exp-47-first-page");
  const isExp63On = useFeatureIsOn("exp-63-yt-redirect");
  if (isExp63On) {
    window.location.href = "https://onboarding.12min.com/start?type=yt&lng=pt"
    return <></>;
  }
  return isExp47 ? <WelcomeExp /> : <Welcome />;
}

export default Start;
